var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BModal",
    {
      attrs: { "has-modal-card": "", "trap-focus": "", active: "" },
      on: { close: _vm.closeModal }
    },
    [
      _c("div", { staticClass: "customer-invoices" }, [
        _c("div", { staticClass: "modal-card" }, [
          _c(
            "header",
            { staticClass: "modal-card-head" },
            [
              _c("p", { staticClass: "modal-card-title" }, [
                _vm._v(
                  "\n          Selecciona las facturas a relacionar\n        "
                )
              ]),
              _c(
                "BField",
                { attrs: { label: "Tipo de relación" } },
                [
                  _c(
                    "BSelect",
                    {
                      attrs: { id: "relation-type" },
                      model: {
                        value: _vm.relationType,
                        callback: function($$v) {
                          _vm.relationType = $$v
                        },
                        expression: "relationType"
                      }
                    },
                    [
                      _c("option", { attrs: { value: "01" } }, [
                        _vm._v(
                          "\n              Nota de Crédito de los documentos relacionados\n            "
                        )
                      ]),
                      _c("option", { attrs: { value: "03" } }, [
                        _vm._v(
                          "\n              Devolución de mercancía sobre facturas o traslados previos\n            "
                        )
                      ])
                    ]
                  )
                ],
                1
              ),
              _c("AppPagination", {
                staticClass: "is-centered",
                attrs: {
                  "current-page": _vm.currentPage,
                  "buttons-max": _vm.buttonsMax,
                  "pages-total": _vm.totalPages
                },
                on: { change: _vm.goToPage }
              })
            ],
            1
          ),
          _c("section", { staticClass: "modal-card-body" }, [
            _c(
              "div",
              { staticClass: "table-container" },
              [
                _c(
                  "BTable",
                  {
                    attrs: {
                      data: _vm.invoices,
                      "checked-rows": _vm.checkedRows,
                      columns: _vm.columns,
                      loading: _vm.loading,
                      "custom-is-checked": function(checkedRows, invoices) {
                        return checkedRows.id === invoices.id
                      },
                      checkable: ""
                    },
                    on: {
                      "update:checkedRows": function($event) {
                        _vm.checkedRows = $event
                      },
                      "update:checked-rows": function($event) {
                        _vm.checkedRows = $event
                      }
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(props) {
                          return [
                            _c(
                              "BTableColumn",
                              {
                                attrs: {
                                  field: "folio",
                                  label: "Folio",
                                  internal: ""
                                }
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(props.row.folio) +
                                    "\n              "
                                )
                              ]
                            ),
                            _c(
                              "BTableColumn",
                              {
                                attrs: {
                                  field: "total",
                                  label: "Monto",
                                  internal: ""
                                }
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm._f("toCurrency")(
                                        props.row.cfdi.voucherTotal,
                                        props.row.cfdi.voucherCurrency
                                      )
                                    ) +
                                    "\n              "
                                )
                              ]
                            ),
                            _c(
                              "BTableColumn",
                              {
                                attrs: {
                                  field: "moneda",
                                  label: "Moneda",
                                  internal: ""
                                }
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(props.row.cfdi.voucherCurrency) +
                                    "\n              "
                                )
                              ]
                            ),
                            _c(
                              "BTableColumn",
                              {
                                attrs: {
                                  field: "receiverName",
                                  label: "Receptor",
                                  internal: ""
                                }
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(props.row.cfdi.receiverName) +
                                    "\n              "
                                )
                              ]
                            ),
                            _c(
                              "BTableColumn",
                              {
                                attrs: {
                                  field: "fecha",
                                  label: "Fecha",
                                  internal: ""
                                }
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm._f("toHumanDate")(
                                        props.row.cfdi.voucherDate
                                      )
                                    ) +
                                    "\n              "
                                )
                              ]
                            )
                          ]
                        }
                      }
                    ])
                  },
                  [
                    _c("template", { slot: "empty" }, [
                      _c("section", { staticClass: "section" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "content has-text-grey has-text-centered"
                          },
                          [
                            _c(
                              "p",
                              [
                                _c("BIcon", {
                                  attrs: {
                                    icon: "emoticon-sad",
                                    size: "is-large"
                                  }
                                })
                              ],
                              1
                            ),
                            _c("p", [
                              _vm._v(
                                "No se encontraron facturas emitidas a este cliente"
                              )
                            ])
                          ]
                        )
                      ])
                    ])
                  ],
                  2
                )
              ],
              1
            )
          ]),
          _c("footer", { staticClass: "modal-card-foot" }, [
            _c(
              "button",
              {
                staticClass: "button",
                attrs: { type: "button" },
                on: { click: _vm.closeModal }
              },
              [_vm._v("\n          Cerrar\n        ")]
            ),
            _c(
              "button",
              {
                staticClass: "button is-primary",
                attrs: { type: "button" },
                on: { click: _vm.addInvoices }
              },
              [_vm._v("\n          Agregar facturas\n        ")]
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }